module.exports = __webpack_public_path__ + "static/media/CSS3_logo.b1b2685a.svg";